
import React, { useEffect, useState , useRef } from "react";
// import { translateThumbs } from "react-range/lib/utils";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { use } from "react";
import { api_url } from "../config/config";
import { Range } from 'react-range';
import { toast } from 'react-toastify';

const AddProduct = () => {
  const navigate = useNavigate();
  const [productName, setProductName] = useState("");
  const [consumeDropdownOpen, setConsumeDropdownOpen] = useState(false);
const [selectedConsumeType, setSelectedConsumeType] = useState("");

  const [concernDropdownOpen, setConcernDropdownOpen] = useState(false);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [alterDropdownOpen,setAlterDropdownOpen] = useState(false);
  const [primaryimage,setPrimaryimage] = useState([])
  const [additionalimage,setAdditionalimage]= useState([])
  const [Price,setPrice] = useState('')
  const [productCode, setProductCode] = useState("");
  const [primaryUse, setPrimaryUse] = useState('');
  const [shelfRackNo, setShelfRackNo] = useState('');
  const [storageInstruction, setStorageInstruction] = useState('');
  const [productDescription, setProductDescription] = useState("");
  const [keyIngredients, setKeyIngredients] = useState('');
  const [prescription, setPrescription] = useState('No');
  const [consumeType, setConsumeType] = useState('');
  const [benefits, setBenefits] = useState('');
  const [packType, setPackType] = useState("");
  const [selectedPackType, setSelectedPackType] = useState(""); // ✅ Now defined
  

  const [composition, setComposition] = useState("");
  const [safetyAdvice, setSafetyAdvice] = useState('');
  const [discountedPrice, setDiscountedPrice] = useState(0);
  const [sideEffects, setSideEffects] = useState(''); 
  const [productDiscount, setProductDiscount] = useState(0);
  const [manufacturer, setManufacturer] = useState("");
  const [howToUse, setHowToUse] = useState('');
  const [returnPolicy, setReturnPolicy] = useState("");
  const [quantity, setQuantity] = useState(null);
  const [alternative, setAlternative] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const dropdownRef = useRef(null);
  const categoryDropdownRef = useRef(null);
  const alterdropdownRef = useRef(null)
  const  [concernids,setConernids] = useState([]);
  const [cateids,setCateIds] = useState([])
  const [manufacturerDropdownOpen, setManufacturerDropdownOpen] = useState(false);
  const [searchManufacturer, setSearchManufacturer] = useState("");
  const [selectedManufacturer, setSelectedManufacturer] = useState(""); // Store single selected manufacturer
  
  const [NextValue, setNextValue] = useState(false)
  const [subcat, setSubcat] = useState([])
  const [expiryDate, setExpiryDate] = useState('');
  const [viewAllCate, setViewAllCate] = useState([]);
  const [viewAllAlters,setViewAllAlter] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [concern, setConcern] = useState([]);
  const [productconcern,setProductConcern] = useState('')
  const [viewAllConcerns, setViewAllConcerns] = useState([]);
  const [viewAllManufacturers, setViewAllManufacturers] = useState([]);
  const [packSize, setPackSize] = useState('');
  const [productSize, setProductSize] = useState('');
  const [searchQuery, setSearchQuery] = useState("");


  const [images, setImages] = useState([{}]); 
  const [previewPrimaryImages, setPreviewPrimaryImages] = useState([]);
  const [previewAdditionalImages, setPreviewAdditionalImages] = useState([]);

    const [variants, setVariants] = useState([
      { pack_size: "", quantity: null, price: null, product_size: "" },
    ]);
  
    const handleAddVariant = () => {
      setVariants([
        ...variants,
        { pack_size: "", quantity: null, price: null, product_size: "" },
      ]);
    };

  const handlePrimaryUseChange = (e) => {
    setPrimaryUse(e.target.value); // Update the state on change
  };

  

  const handleManufacturerSelection = (manufacturerId) => {
    setSelectedManufacturer(manufacturerId); 
    setManufacturer(manufacturerId); // ✅ Ensures `manufacturer` is updated for API request
    setManufacturerDropdownOpen(false);
  };
  

  
  const handleBenefitsChange = (e) => {
    setBenefits(e.target.value); // Update the state with the input value
  };
 
  const handleSaveChanges = async (e) => {
    e.preventDefault();

    // Validation for mandatory fields
    if (!productName.trim()) {
      alert("Product Name is required");
      return;
    }
    if (!productCode.trim()) {
      alert("Product Code is required");
      return;
    }
    if (!productDescription.trim()) {
      alert("Product Description is required");
      return;
    }
    // Check if Primary Image is uploaded
    if (primaryimage.length === 0) {
      alert("Primary Image is required");
      return;
    }

    // Check if Expiry Date is provided
    if (!expiryDate) {
      alert("Expiry Date is required");
      return;
    }

    // Check if all variants have a price
    for (const variant of variants) {
      if (!variant.price) {
        alert(`Price is required for variant ${variant.product_size}`);
        return;
      }
    }

    var formData = new FormData();
    formData.append("name", productName);
    formData.append("product_code", productCode);
    formData.append("description", productDescription);
    formData.append("product_concern", concern);
    formData.append("composition", composition);
    formData.append("pack_type", packType);
    formData.append("consume_type", consumeType);
    formData.append("discount_percent", productDiscount);

    // Append Expiry Date
    formData.append("expire_date", expiryDate);

    formData.append("benefits", benefits);
    formData.append("how_to_use", howToUse);
    formData.append("safety_advise", safetyAdvice);
    formData.append("prescription_required", prescription);
    formData.append("primary_use", primaryUse);
    formData.append("storage_instruction", storageInstruction);
    formData.append("side_effects", sideEffects);
    formData.append("return_policy", returnPolicy);
    formData.append("alternatives", alternative);
    formData.append("key_ingredients", keyIngredients);
    formData.append("shelf_rack_no", shelfRackNo);
    formData.append("concern_ids", JSON.stringify([...concern]));
    
    formData.append("category_ids", JSON.stringify([...productCategory]));

    formData.append("manufacturer_id", manufacturer);
    
    formData.append("primary", primaryimage); 


    if (!primaryimage) {
      alert("Primary image is required");
      return;
    }

    formData.append("variant", JSON.stringify(variants));

    for (let i = 0; i < additionalimage.length; i++) {    
      formData.append("additional", additionalimage[i]); 
    }

 


    try {
      const response = await fetch(`${api_url}/product`, {
        method: "POST",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        alert("Product details successfully submitted!");
        navigate("/ng-admin/product-list");
      } else {
        const error = await response.json();
        console.error("API Error:", error.data);

        // Construct error message
        let errorMessage = "Form submission failed:\n";

        if (error.data) {
          errorMessage += `${error.data}\n`;
        }

        if (error.errors && typeof error.errors === "object") {
          Object.entries(error.errors).forEach(([field, msg]) => {
            errorMessage += `\n🔴 ${field}: ${msg}`;
          });
        }

        alert(errorMessage);
      }
    } catch (error) {
      console.error("Network Error:", error);
      alert("❌ Network Error: An error occurred while submitting the form. Please try again.");
    }
};


  
  
  


  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);

    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  };
  const handleQuantityChange = (e) => {
    setQuantity(e.target.value);
  };

  const handleHowToUseChange = (e) => {
    setHowToUse(e.target.value); // Update the state with the input value
  };

  const handleSideEffectsChange = (e) => {
    setSideEffects(e.target.value); // Update the state on change
  };

  const handleStorageInstructionChange = (e) => {
    setStorageInstruction(e.target.value); // Update the state on change
  };

  const handleSafetyAdviceChange = (e) => {
    setSafetyAdvice(e.target.value); // Update the state with the input value
  };

  const handleCancel = () => {
    navigate("/ng-admin/product-list")
  }


    const handleExpiryDateChange = (e) => {
      const selectedDate = e.target.value;

      setExpiryDate(selectedDate); 
    };
  
  
    const handleRemoveVariant = (index) => {
      setVariants(variants.filter((_, i) => i !== index));
    };
  
    const handleVariantChange = (index, field, value) => {
      const updatedVariants = variants.map((variant, i) =>
        i === index ? { ...variant, [field]: value } : variant
      );
      setVariants(updatedVariants);
    };


  
  

   // Handle change for consume type selection
   const handleConsumeTypeChange = (e) => {
    setConsumeType(e.target.value); // Update the state with selected value
  };

  const handlePrescriptionChange = (e) => {
    setPrescription(e.target.value); // Update the state with the selected value
  };

  const handleImageAdd = () => {
    document.getElementById("imageInput").click();
  };

  const handleNextChanges = (e) => {
    e.preventDefault();

    let missingFields = [];

    if (!productName.trim()) missingFields.push("Product Name");
    if (!productCode.trim()) missingFields.push("Product Code");
    if (!productDescription.trim()) missingFields.push("Product Description");
    if (!expiryDate.trim()) missingFields.push("Expire Date");

    if (missingFields.length > 0) {
        alert(`Please fill in: ${missingFields.join(", ")}`);
        return; // Stop function execution if errors exist
    }

    if(expiryDate < new Date().toISOString().split('T')[0]){
      alert("Expire Date cannot be less than today's date");
      return;
    }

    // ✅ Use functional update to ensure React re-renders properly
    setNextValue((prev) => !prev);
};


  
  

  const handlebackChanges = (e) => {
    e.preventDefault()
    setNextValue(false)
  }


  
  const fetchConcerns = async () => {
    try {
      const { data } = await axios.get(
        `${api_url}/concerns?page=1&limit=100`,
        {
          headers: { "Content-Type": "multipart/form-data ", 
          
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        
         },
        }
      );

      // Extract only the name of each concern and set it to the state
      setViewAllConcerns(data.results);
      const concernIds = data.results.map((concern) => concern.concern_id); 
      // localStorage.setItem("concern_ids", JSON.stringify(concernIds));           //HI
    } catch (e) {
      console.error('Error fetching concerns:', e);
    }
  };


useEffect(() => {
    fetchConcerns();
}, []);


const filteredConcerns = viewAllConcerns.filter((item) =>
  item.name.toLowerCase().includes(searchQuery) // Filter based on the search query
);

const filteredAlternative = viewAllAlters.filter((item)=>
item.name.toLowerCase().includes(searchQuery)
);


const fetchCategory = async () => {
  try {
    const { data } = await axios.get(
      `${api_url}/categories?page=1&limit=100`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
      }

    );

    // Extract category names from the 'results' array
    setViewAllCate(data.results);
    const categoryIds = data.results.map((category) => category.category_id); 
    // localStorage.setItem("category_ids", JSON.stringify(categoryIds));
  } catch (e) {
    console.error("Error fetching categories:", e);
  }
};

useEffect(() => {
  fetchCategory();
}, []);





const toggleCategoryDropdown = () => {
  setCategoryDropdownOpen(!categoryDropdownOpen);
  setSearchQuery(""); // Reset search when dropdown opens
};

const toggleAlterDropdown = () => {
  setAlterDropdownOpen(!alterDropdownOpen);
  setSearchQuery(""); // Reset search when dropdown opens
};

const handleCheckboxChange = async(event, categoryId) => {
  if (event.target.checked) {
    setProductCategory((prevCategories) => [...prevCategories, categoryId]);
    try{
    const alternativeProducts = await axios.post(`${api_url}/alternative-products`,
      {
        concern_ids: [...concern],
        category_ids: [...cateids,categoryId],
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
      }
    );

    setViewAllAlter(alternativeProducts.data);
  } catch (error) {
    setViewAllAlter([]);
    console.error('Error adding alternative products:', error);
  }
  } else {
    // Remove category from the selected list
    setProductCategory((prevCategories) =>
      prevCategories.filter((id) => id !== categoryId)
    );
    try{
      const alternativeProducts = await axios.post(`${api_url}/alternative-products`,
        {
          concern_ids: [...concern],
          category_ids: [...cateids.filter((id) => id !== categoryId)],
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
          },
        }
      );

      setViewAllAlter(alternativeProducts.data);
    } catch (error) {
      setViewAllAlter([]);
      console.error('Error adding alternative products:', error);
    }
  }
};






const handleCheckboxAlter = async (event, productId) => {
  const isChecked = event.target.checked;
  let updatedAlternatives = [...alternative];

  if (isChecked) {
    updatedAlternatives.push(productId);
  } else {
    updatedAlternatives = updatedAlternatives.filter(id => id !== productId);
  }

  setAlternative(updatedAlternatives);

  // ✅ Ensure `productCode` is set before API call
  if (!productCode) {
    console.error("Product code is missing!");
    return;
  }

  // ✅ Pass both `productId` and `productCode` to API
  const requestBody = {
    product_ids: updatedAlternatives, // Array of selected product IDs
    product_code: productCode 
  };

  try {
    const response = await fetch(`${api_url}/api/alternative`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
 

    if (!response.ok) {
      throw new Error(data.message || "Failed to create alternative");
    }
  } catch (error) {
    console.error("Error creating alternative:", error.message);
  }
};


const handleConsumeTypeSelection = (type) => {
  setSelectedConsumeType(type); 
  setConsumeType(type); // ✅ Ensures consumeType is set before API request
  setConsumeDropdownOpen(false);
};






const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
};

// Filter categories based on the search query
const filteredCategories = viewAllCate.filter((category) =>
  category.category_name.toLowerCase().includes(searchQuery.toLowerCase())
);




   

  const fetchManufacturers = async () => {
    try {
      // Make API call
      const { data } = await axios.get(
        `${api_url}/manufacturer?page=1&limit=10`,
        {
          headers: { "Content-Type": "multipart/form-data ", 
          
            'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        
         },
        }
      );


      // Extract 'name' from each manufacturer in the results array
      if (data && data.results) {
        const manufacturers = data.results.map((item) => item.name);
        setViewAllManufacturers(data.results); // Set state with extracted names
      }
    } catch (error) {
      console.error('Error fetching manufacturers:', error);
    }
  };

  // Call fetchManufacturers when the component mounts
  useEffect(() => {
    fetchManufacturers();
  }, []);

 
  
  // Filter manufacturers based on the search query
  const filteredManufacturers = viewAllManufacturers.filter((manufacturer) =>
    manufacturer.name.toLowerCase().includes(searchQuery)
  );

  useEffect(() => {
    fetchCategory();

  }, [])

 
  const handlePackTypeSelection = (type) => {
    setSelectedPackType(type);
    setPackType(type); // ✅ Ensures `packType` is updated for API request
  };
  



  const handlePrimaryImageChange = (file) => {
    const maxFileSize = 2 * 1024 * 1024; // 2MB limit
setPrimaryimage(file)
    if (file) {
      if (file.size > maxFileSize) {
        console.log(`File ${file.name} exceeds the size limit of 2MB.`);
        return;
      }

      const previewUrl = URL.createObjectURL(file); // Efficient preview
      setPreviewPrimaryImages(previewUrl); // Update the state
    }
  };

  const handleAdditionalImagesChanges = (files) => {
    const maxFileSize = 2 * 1024 * 1024; // 2MB limit

    const imagesArray = Array.from(files);
 setAdditionalimage(imagesArray)

 const preiewarray = [];

    imagesArray.forEach((file) => {
      if (file.size > maxFileSize) {
        console.warn(`File ${file.name} exceeds the size limit of 2MB.`);
        return;
      }

      const previewUrl = URL.createObjectURL(file); 
      preiewarray.push(previewUrl)
      


  })
  setPreviewAdditionalImages(preiewarray); 
  };


    // Handle concern checkbox changes
    const handleConcernCheckboxChange = async (event, concernId) => {
  if (event.target.checked) {
    // Add concern to selected list
    setConcern((prevConcerns) => [...prevConcerns, concernId]);
    try{
    const alternativeProducts = await axios.post(`${api_url}/alternative-products`,
      {
        concern_ids: [...concern, concernId],
        category_ids: [...cateids],
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
      }
    );

    setViewAllAlter(alternativeProducts.data);
  } catch (error) {
    setViewAllAlter([]);
    console.error('Error adding alternative products:', error);
  }
  } else {
    // Remove concern from selected list
    setConcern((prevConcerns) => prevConcerns.filter((id) => id !== concernId));
    try{
    const alternativeProducts = await axios.post(`${api_url}/alternative-products`,
      {
        concern_ids: [...concern.filter((id) => id !== concernId)],
        category_ids: [...cateids],
      },  
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('admin_token'),
        },
      }
    );

    setViewAllAlter(alternativeProducts.data);
    if (alternativeProducts.data.length === 0) {
      setViewAllAlter([]);
    }
  }catch{
    setViewAllAlter([]);
    console.error('Error adding alternative products');
  }
  }
  
};

  
    // Toggle concern dropdown and close category dropdown
   const toggleConcernDropdown = () => {
  setConcernDropdownOpen((prev) => !prev);
  setCategoryDropdownOpen(false); // Close category dropdown when concern opens
};

useEffect(() => {
  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setConcernDropdownOpen(false);
    }
  }

  if (concernDropdownOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [concernDropdownOpen]);



const addAlternativeProducts = async () => {
  if (concernids.length === 0 && cateids.length === 0) {  // ✅ Prevent unnecessary API call
    console.log("No concerns or categories selected.");
    return;
  }

  try {
    const response = await axios.post(`${api_url}/alternative-products`, {
      concern_ids: concernids,
      category_ids: cateids
    });

    console.log('Alternative products added:', response.data);
    setViewAllAlter(response.data);
  } catch (error) {
    console.error('Error adding alternative products:', error);
  }
};

useEffect(() => {
  if (concernids.length > 0 || cateids.length > 0) {  // ✅ Ensures valid data before API call
    addAlternativeProducts();
  }
}, [concernids, cateids]);


const createAlternative = async (productIds, productCode) => {
  try {


    if (!Array.isArray(productIds) || productIds.length === 0) {
      throw new Error("Invalid or empty product_ids array");
    }

    const response = await fetch(`${api_url}/api/alternative`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
      body: JSON.stringify({
        product_ids: productIds,
        product_code: productCode,
      }),
    });

    const data = await response.json();
    console.log("API Response:", data);

    if (response.ok) {
      console.log("Alternative Created Successfully:", data);
      return data;
    } else {
      console.error("Error creating alternative:", data.message);
      throw new Error(data.message || "Failed to create alternative");
    }
  } catch (error) {
    console.error("Request failed:", error.message);
    throw error;
  }
};



useEffect(() => {
  function handleClickOutside(event) {
    if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
      setCategoryDropdownOpen(false);
    }
  }

  if (categoryDropdownOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [categoryDropdownOpen]);


useEffect(() => {
  function handleClickOutside(event) {
    if (alterdropdownRef.current && !alterdropdownRef.current.contains(event.target)) {
      setAlterDropdownOpen(false);
    }
  }

  if (alterDropdownOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [alterDropdownOpen]);



  return (
    <div className="p-6 bg-gray-100 min-h-screen ">
        
      <h2 className="text-2xl font-semibold mb-3">Add Product</h2>

      <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg p-6">
       

        {
          !NextValue ? <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            <div>
              <div className="mb-6">
                <h2 className="text-lg font-semibold mb-4">Basic Information</h2>
                <div className="mb-4">
  <label
    htmlFor="productName"
    className="block text-sm font-medium text-gray-700 mb-2"
  >
    Product Name <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="name"
    className={`w-full border ${
      productName.trim() === "" ? "border-red-500" : "border-gray-300"
    } rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500`}
    placeholder="Enter product name"
    value={productName}
    onChange={(e) => setProductName(e.target.value)}
    required
  />
  {productName.trim() === "" && (
    <p className="text-red-500 text-sm mt-1">Product Name is required</p>
  )}
</div>

<div className="mb-4">
  <label
    htmlFor="productCode"
    className="block text-sm font-medium text-gray-700 mb-2"
  >
    Product Code <span className="text-red-500">*</span>
  </label>
  <input
    type="text"
    id="productCode"
    className={`w-full border ${
      productCode.trim() === "" ? "border-red-500" : "border-gray-300"
    } rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500`}
    placeholder="Enter product code"
    value={productCode}
    onChange={(e) => setProductCode(e.target.value)}
    required
  />
  {productCode.trim() === "" && (
    <p className="text-red-500 text-sm mt-1">Product Code is required</p>
  )}
</div>

<div className="mb-4">
  <label
    htmlFor="productDescription"
    className="block text-sm font-medium text-gray-700 mb-2"
  >
    Product Description <span className="text-red-500">*</span>
  </label>
  <textarea
    id="productDescription"
    rows="5"
    className={`w-full border ${
      productDescription.trim() === "" ? "border-red-500" : "border-gray-300"
    } rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500`}
    value={productDescription}
    onChange={(e) => setProductDescription(e.target.value)}
    required
  />
  {productDescription.trim() === "" && (
    <p className="text-red-500 text-sm mt-1">Product Description is required</p>
  )}
</div>


         
              </div>


             {/* product category */}

              <div className="mb-6">
                <h2 className="text-lg font-semibold mb-4">Product Details</h2>
                <div>
                <div className="mb-4 relative">
      <label
        htmlFor="productCategory"
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        Product Category
      </label>

      {/* Custom Dropdown */}
    <div className="relative" ref={categoryDropdownRef}>
  <div
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
    onClick={toggleCategoryDropdown}
  >
    <span>
      {productCategory.length > 0
        ? viewAllCate
            .filter((category) => productCategory.includes(category.category_id))
            .map((cat) => cat.category_name)
            .join(", ")
        : "Select a category"}
    </span>
    <span className="text-gray-500">
      {categoryDropdownOpen ? "▲" : "▼"}
    </span>
  </div>

  {categoryDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      <div className="p-2">
        <input
          type="text"
          placeholder="Search categories..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      {filteredCategories.length > 0 ? (
        filteredCategories.map((category) => (
          <div key={category.category_id} className="flex items-center px-3 py-2">
            <input
              type="checkbox"
              id={`category_${category.category_id}`}
              name={`category_${category.category_name}`}
              value={category.category_id}
              checked={productCategory.includes(category.category_id)}
              onChange={(e) => handleCheckboxChange(e, category.category_id)}
              className="mr-2"
            />
            <label
              htmlFor={`category_${category.category_id}`}
              className="text-sm text-gray-700"
            >
              {category.category_name}
            </label>
          </div>
        ))
      ) : (
        <div className="text-sm text-gray-500 px-3 py-2">No categories found.</div>
      )}
    </div>
  )}
</div>


    </div>

    </div>  


    <div>

      {/* concern  */}

      <div className="mb-4 relative">
    <label htmlFor="concern" className="block text-sm font-medium text-gray-700 mb-2">
      Concern
    </label>

    {/* Custom Dropdown */}
    <div className="relative" ref={dropdownRef}>
  <div
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
    onClick={toggleConcernDropdown}
  >
    <span>
      {concern.length > 0
        ? viewAllConcerns
            .filter((item) => concern.includes(item.concern_id))
            .map((item) => item.name)
            .join(", ")
        : "Select a concern"}
    </span>
    <span className="text-gray-500">
      {concernDropdownOpen ? "▲" : "▼"}
    </span>
  </div>

  {concernDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      {/* Search Input */}
      <div className="px-3 py-2">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      {/* Filtered Concerns List */}
      {filteredConcerns.length > 0 ? (
        filteredConcerns.map((item) => (
          <div key={item.concern_id} className="flex items-center px-3 py-2">
            <input
              type="checkbox"
              id={`concern_${item.concern_id}`}
              name={`concern_${item.concern_id}`}
              value={item.concern_id}
              checked={concern.includes(item.concern_id)}
              onChange={(e) => handleConcernCheckboxChange(e, item.concern_id)}
              className="mr-2"
            />
            <label htmlFor={`concern_${item.concern_id}`} className="text-sm text-gray-700">
              {item.name}
            </label>
          </div>
        ))
      ) : (
        <div className="text-sm text-gray-500 px-3 py-2">
          No concerns found.
        </div>
      )}
    </div>
  )}
</div>


  </div>

</div>


    


              {/* manufacturere */}
              <div className="mb-4 relative">
  <label htmlFor="manufacturer" className="block text-sm font-medium text-gray-700 mb-2">
    Manufacturer
  </label>

  {/* Custom Dropdown */}
  <div
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
    onClick={() => setManufacturerDropdownOpen(!manufacturerDropdownOpen)}
  >
    <span>
      {selectedManufacturer
        ? viewAllManufacturers.find((manu) => manu.manufacturer_id === selectedManufacturer)?.name
        : "Select a manufacturer"}
    </span>
    {/* Dropdown Arrow */}
    <span className="text-gray-500">{manufacturerDropdownOpen ? "▲" : "▼"}</span>
  </div>

  {manufacturerDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      {/* Search Input */}
      <div className="p-2">
        <input
          type="text"
          placeholder="Search manufacturers..."
          value={searchManufacturer}
          onChange={(e) => setSearchManufacturer(e.target.value)}
          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Manufacturer List */}
      {/* {Array.isArray(viewAllManufacturers) && viewAllManufacturers.length > 0 ? (
        viewAllManufacturers
          .filter((item) =>
            item.name.toLowerCase().includes(searchManufacturer.toLowerCase())
          )
          .map((item) => (
            <div
              key={item.manufacturer_id}
              className={`px-3 py-2 hover:bg-gray-100 cursor-pointer ${
                selectedManufacturer === item.manufacturer_id ? "bg-blue-100" : ""
              }`}
              onClick={() => handleManufacturerSelection(item.manufacturer_id)}
            >
              {item.name}
            </div>
          ))
      ) : (
        <div className="p-3 text-sm text-gray-500">No manufacturers available</div>
      )} */}

{filteredManufacturers.map((item) => (
  <div
    key={item.manufacturer_id}
    onClick={() => handleManufacturerSelection(item.manufacturer_id)}
    className={`px-3 py-2 hover:bg-gray-100 cursor-pointer ${
      selectedManufacturer === item.manufacturer_id ? "bg-blue-100" : ""
    }`}
  >
    {item.name}
  </div>
))}

    </div>
  )}
</div>


              {/* consume type */}

              <div className="mb-4 relative">
  <label htmlFor="consume_type" className="block text-sm font-medium text-gray-700 mb-2">
    Consume Type:
  </label>

  {/* Custom Dropdown */}
  <div
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
    onClick={() => setConsumeDropdownOpen(!consumeDropdownOpen)}
  >
    <span>
      {selectedConsumeType ? selectedConsumeType : "Select Consume Type"}
    </span>
    {/* Dropdown Arrow */}
    <span className="text-gray-500">{consumeDropdownOpen ? "▲" : "▼"}</span>
  </div>

  {consumeDropdownOpen && (
    <div
      className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto"
      style={{ maxHeight: "200px" }}
    >
      {/* Consume Type List */}
      {["Oral", "Non Consumable", "Topical", "Injectable", "Inhalable"].map((type) => (
        <div
          key={type}
          className={`px-3 py-2 hover:bg-gray-100 cursor-pointer ${
            selectedConsumeType === type ? "bg-blue-100" : ""
          }`}
          onClick={() => handleConsumeTypeSelection(type)}
        >
          {type}
        </div>
      ))}
    </div>
  )}
</div>

    
           
            {/* <!-- Alternative --> */}
            <div className="mb-4 relative">
  <label htmlFor="productCategory" className="block text-sm font-medium text-gray-700 mb-2">
    Alternative
  </label>

  {/* Custom Dropdown */}
  <div className="relative" ref={alterdropdownRef}>
    <div
      className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 cursor-pointer flex justify-between items-center"
      onClick={toggleAlterDropdown}
    >
      <span>
        {alternative.length > 0
          ? viewAllAlters
              .filter((alter) => alternative.includes(alter.product_id))
              .map((cat) => cat.name)
              .join(", ")
          : "Select alternative"}
      </span>
      {/* Dropdown Arrow */}
      <span className="text-gray-500">{alterDropdownOpen ? "▲" : "▼"}</span>
    </div>

    {alterDropdownOpen && (
      <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-52 overflow-y-auto">
        {/* Search Input */}
        <div className="p-2">
          <input
            type="text"
            placeholder="Search alternatives..."
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Filtered alternatives */}
        {filteredAlternative.length > 0 ? (
          filteredAlternative.map((alt) => (
            <div key={alt.product_id} className="flex items-center px-3 py-2">
              <input
                type="checkbox"
                id={`alternative_${alt.product_id}`}
                name={`alternative_${alt.name}`}
                value={alt.product_id}
                checked={alternative.includes(alt.product_id)}
                onChange={(e) => handleCheckboxAlter(e, alt.product_id)}
                // onChange={(e) => setProductCode(e.target.value)}
                className="mr-2"
              />
              <label htmlFor={`alternative_${alt.product_id}`} className="text-sm text-gray-700">
                {alt.name}
              </label>
            </div>
          ))
        ) : (
          <div className="text-sm text-gray-500 px-3 py-2">No Alternative found.</div>
        )}
      </div>
    )}
  </div>
</div>



        {/* <!-- Primary Use --> */}

     <div className="mb-4">
    <label htmlFor="primaryUse" className="block text-gray-700 font-medium mb-2">
      Primary Use
    </label>
    <input 
      type="text" 
      id="primary_use" 
      name="primaryUse" 
      value={primaryUse} // Bind the value of the input to the state
      onChange={handlePrimaryUseChange} // Update the state when the input changes
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter primary use of medicine"
      required
    />
  </div>

         {/* composition */}

         <div className="mb-4">
      <label htmlFor="composition" className="block text-gray-700 font-medium mb-2">
        Composition
      </label>
      <textarea
        id="composition"
        name="composition"
        value={composition} // Bind the state variable
        onChange={(e) => setComposition(e.target.value)} // Update state on change
        rows="3"
        className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        placeholder="Enter storage instructions"
      ></textarea>

    </div>
         
               {/* key ingredients */}
               <div className="mb-4">
    <label
      htmlFor="keyingredients"
      className="block text-gray-700 font-medium mb-2"
    >
      Key Ingredients
    </label>
    <input
      type="text"
      id="key_ingredients"
      name="keyingredients"
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter key ingredients"
      value={keyIngredients} // Bind value to state
      onChange={(e) => setKeyIngredients(e.target.value)} // Update state on change
    />
  </div>
        
              </div>
            </div>


            <div>

              <div className="mb-4">
                <h2 className="text-lg font-semibold mb-10">
                 
                </h2>
           


                {/* <!-- Expiry Date Input --> */}
                <div className="mb-4">
      <label htmlFor="expiryDate" className="block text-gray-700 font-medium mb-2">
        Expire Date <span className="text-red-500">*</span>
      </label>
      <input 
        type="date"
        id="expire_date" 
        name="expiryDate" 
        value={expiryDate}
        onChange={handleExpiryDateChange}
        min={new Date().toISOString().split("T")[0]} 
        // onKeyDown={(e) => e.preventDefault()} 
        required
        className={`w-full border ${
          expiryDate.trim() === "" ? "border-red-500" : "border-gray-300"
        } rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none`}
      />
      {expiryDate.trim() === "" && (
        <p className="text-red-500 text-sm mt-1">Expire Date is required</p>
      )}
    </div>


     {/* <!-- benefits  Input --> */}
      <div className="mb-4">
        <label htmlFor="Benefits" className="block text-gray-700 font-medium mb-2">
          Benefits
        </label>
        <input
          type="text"
          id="Benefits"
          name="Benefits"
          value={benefits} // Bind state value to the input
          onChange={handleBenefitsChange} // Update state on change
          required
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        />
      </div>

   


            {/* <!-- Side Effects --> */}
            <div className="mb-4">
    <label htmlFor="sideEffects" className="block text-gray-700 font-medium mb-2">
      Side Effects
    </label>
    <textarea
      id="side_effects"
      name="sideEffects"
      rows="3"
      required
      value={sideEffects} // Bind the value of the textarea to the state
      onChange={handleSideEffectsChange} // Update the state when the textarea changes
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter side effects"
    ></textarea>
  </div>

             {/* use of input */}
      <div className="mb-4">
        <label htmlFor="howToUse" className="block text-gray-700 font-medium mb-2">
          How to use
        </label>
        <textarea
          type="text"
          id="how_to_use"
          name="howToUse"
          rows="3"
          required
          value={howToUse} // Bind state value to the input
          onChange={handleHowToUseChange} // Update state on change
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        />
      </div>

  

       

                {/* advice of input */}
      <div className="mb-4">
        <label htmlFor="safetyAdvice" className="block text-gray-700 font-medium mb-2">
          Safety Advice
        </label>
        <input
          type="text"
          id="safety_advise"
          name="safetyAdvice"
          required
          value={safetyAdvice} // Bind state value to the input
          onChange={handleSafetyAdviceChange} // Update state on change
          className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
        />
      </div>
 

    

            {/* <!-- Storage Instructions --> */}
           <div className="mb-4">
    <label htmlFor="storageInstruction" className="block text-gray-700 font-medium mb-2">
      Storage Instruction
    </label>
    <textarea
      id="storage_instruction"
      name="storageInstruction"
      rows="3"
      required
      value={storageInstruction} // Bind the value of the textarea to the state
      onChange={handleStorageInstructionChange} // Update the state when the textarea changes
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter storage instructions"
    ></textarea>
  </div>

              </div>

              

              <div className="mb-6">
                <h2 className="text-lg font-semibold mb-4">
                  Policies & Settings
                </h2>
                <div className="mb-4">
                  <label
                    htmlFor="returnPolicy"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Return Policy
                  </label>
                  <textarea
                    id="return_policy"
                    rows="3"
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500 h-[50px]"
                    value={returnPolicy}
                    onChange={(e) => setReturnPolicy(e.target.value)}
                    required
                  />
                </div>


       {/* <!-- Prescription Required --> */}
    

       <div className="mb-4">
    <label
      htmlFor="prescription_required"
      className="block text-sm font-medium text-gray-700 mb-2"
    >
      Prescription: (Yes/No)
    </label>
    <div className="flex items-center space-x-4">
      <label className="flex items-center">
        <input
          type="radio"
          id="prescription_required"
          name="prescription"
          value="Yes"
          checked={prescription === "Yes"}
          onChange={handlePrescriptionChange}
          required
          className="h-4 w-4 text-blue-500 border-gray-300 focus:ring-blue-500"
        />
        <span className="ml-2 text-sm text-gray-700">Yes</span>
      </label>
      <label className="flex items-center">
        <input
          type="radio"
          id="prescription_required"
          name="prescription"
          value="No"
          checked={prescription === "No"}
          onChange={handlePrescriptionChange}
          className="h-4 w-4 text-blue-500 border-gray-300 focus:ring-blue-500"
        />
        <span className="ml-2 text-sm text-gray-700">No</span>
      </label>
    </div>
  </div>
                



          {/* <!-- Shelf Rack No --> */}
          <div className="mb-4">
    <label
      htmlFor="shelfRackNo"
      className="block text-gray-700 font-medium mb-2"
    >
      Shelf Rack No
    </label>
    <input
      type="text"
      id="shelf_rack_no"
      name="shelfRackNo"
      className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
      placeholder="Enter shelf rack number"
      required
      value={shelfRackNo} // Bind value to state
      onChange={(e) => setShelfRackNo(e.target.value)} // Update state on change
    />
  </div>
              </div>



              <div className="flex items-center justify-end mt-6 space-x-4">



                {/* Save Button */}
                <button

                  onClick={(e) => handleNextChanges(e)}
                  className="bg-[#3C1F1F] text-white px-6 w-[40%] py-3 rounded-lg"
                >
                  Next
                </button>
              </div>

            </div>

          </div> : (
            <div className=" relative">
              <div className="mb-4">
                <label
                  htmlFor="returnPolicy"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Discount Percentage
                </label>
                <input
                  id="discount_percent"
                  type="number"
                  className="w-[100px] border border-gray-300 rounded-lg p-3 focus:ring-blue-500 focus:border-blue-500"
                  value={productDiscount}
                  onChange={(e) => setProductDiscount(e.target.value)}
                  required
                />
              </div>

              {/* pack type */}
              <div className="mb-4">
  <label className="block text-sm font-medium text-gray-700 mb-1">
    Pack Type:
  </label>
  <select
  id="pack_type"
  className="w-40 border border-gray-300 rounded-lg p-2 focus:ring-blue-500 focus:border-blue-500"
  value={selectedPackType} // ✅ Uses selectedPackType for UI consistency
  onChange={(e) => handlePackTypeSelection(e.target.value)} // ✅ Updates both states
  required
>
  <option value="">Select Pack Type</option>
  <option value="Strip">Strip</option>
  <option value="Bottle">Bottle</option>
  <option value="Packet">Packet</option>
  <option value="Jar">Jar</option>
</select>


</div>



<div className="flex gap-5">
      {/* Primary Image */}
      <div className="mb-4">
  <h4 className="text-md font-medium mb-1">
    Primary Image <span className="text-red-500">*</span>
  </h4>
  <input
    type="file"
    id="primary-image"
    className="hidden"
    onChange={(e) => handlePrimaryImageChange(e.target.files[0])}
    required
  />
  <label
    htmlFor="primary-image"
    className={`cursor-pointer w-20 h-20 flex items-center justify-center border ${
      !previewPrimaryImages ? "border-red-500" : "border-dashed border-gray-300"
    } rounded-md text-gray-400 hover:bg-gray-50`}
  >
    Upload
  </label>
  {!previewPrimaryImages && (
    <p className="text-red-500 text-sm mt-1">Primary Image is required</p>
  )}
  {previewPrimaryImages && typeof previewPrimaryImages === "string" && previewPrimaryImages.trim() !== "" && (
    <div className="mt-2">
      <img
        src={previewPrimaryImages}
        alt="Primary Image"
        className="w-20 h-20 object-cover rounded-md border"
      />
    </div>
  )}
</div>




      {/* Additional Images */}
      <div>
        <h4 className="text-md font-medium mb-1">Additional Images</h4>
        <input
          type="file"
          id="additional-images"
          className="hidden"
          required
          multiple
          onChange={(e) => handleAdditionalImagesChanges(e.target.files)}
        />
        <label
          htmlFor="additional-images"
          className="cursor-pointer w-20 h-20 flex items-center justify-center border border-dashed border-gray-300 rounded-md text-gray-400 hover:bg-gray-50"
        >
          Upload
        </label>
        {previewAdditionalImages.length > 0 && (
          <div className="mt-2 flex gap-2">
            {previewAdditionalImages.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Additional Image ${index + 1}`}
                className="w-20 h-20 object-cover rounded-md border"
              />
            ))}
          </div>
        )}
      </div>
    </div>



    <div className="border border-gray-300 rounded-lg p-5 mb-5 space-y-4">
      <h3 className="text-lg font-semibold mb-2">Product Details</h3>
      {variants.map((variant, index) => (
        <div key={index} className="space-y-4 border p-4 rounded-md relative">
          <button
            onClick={() => handleRemoveVariant(index)}
            className="absolute top-2 right-2 px-2 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
          >
            Remove
          </button>
          <div className="flex space-x-4">
            <div className="flex-1">
              <label className="block text-sm font-medium">Pack Size</label>
              <input
                id={`pack_size_${index}`}
                type="text"
                value={variant.pack_size}
                onChange={(e) =>
                  handleVariantChange(index, "pack_size", e.target.value)
                }
                required
                className="mt-1 block w-full p-2 border rounded-md"
              />
            </div>

            <div className="flex-1">
              <label className="block text-sm font-medium">Quantity In Store</label>
              <input
                id={`quantity_${index}`}
                type="number"
                placeholder="Quantity"
                value={variant.quantity}
                required
                onChange={(e) =>
                  handleVariantChange(index, "quantity", e.target.value)
                }
                className="mt-1 block w-full p-2 border rounded-md"
              />
            </div>

            <div className="flex-1">
  <label className="block text-sm font-medium">
    Price <span className="text-red-500">*</span>
  </label>
  <input
    id={`price_${index}`}
    type="number"
    placeholder="Price"
    value={variant.price}
    required
    onChange={(e) => handleVariantChange(index, "price", e.target.value)}
    className={`mt-1 block w-full p-2 border ${
      !variant.price ? "border-red-500" : "border-gray-300"
    } rounded-md`}
  />
  {!variant.price && (
    <p className="text-red-500 text-sm mt-1">Price is required</p>
  )}
</div>

          </div>

          <div>
            <label className="block text-sm font-medium">Product Size</label>
            <input
              id={`product_size_${index}`}
              type="text"
              value={variant.product_size}
              required
              onChange={(e) =>
                handleVariantChange(index, "product_size", e.target.value)
              }
              className="mt-1 block p-2 border rounded-md w-1/4"
            />
          </div>
        </div>
      ))}

      <button
        onClick={handleAddVariant}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        Add Variant
      </button>
    </div>

              <div className="flex gap-4">

                <button className="bg-gray-400 p-2 px-6 rounded-lg "
                  onClick={(e) => handlebackChanges(e)}
                >
                  GoBack
                </button>
                <button className="bg-[#3C1F1F] p-2 px-6 rounded-lg text-white" 
                  onClick={handleSaveChanges}
                >
                  Save
                </button>
              </div>
            </div>

          )
        }

      </div>
    </div>
  );
};

export default AddProduct;
